import { Component, OnInit, ChangeDetectionStrategy, Input, Renderer2, OnDestroy } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as State from '@shared/state/interface';

import { Observable, of } from 'rxjs';
import { ILoyaltyAppMessageModel } from '@shared/state/interface';

@Component({
    selector: 'shared-loyalty-messages',
    templateUrl: './loyalty-messages.shared.component.html',
    styleUrls: ['./loyalty-messages.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoyaltyMessagesComponent implements OnInit, OnDestroy {
    @Input() public dots: boolean = false;
    @Input() public inverted: boolean = true;

    public messages$: Observable<State.ILoyaltyMessages>;

    constructor(
        public controllers: Controllers,
        private _renderer2: Renderer2,
    ) { }

    ngOnInit(): void {
        this.messages$ = this.controllers.loyalty.getLoyaltyMessages$();
        if (this.isiPhone()) {
            this._renderer2.addClass(
                document.body,
                'with-loyalty-messages');
        }
    }

    ngOnDestroy(): void {
        if (this.isiPhone()) {
            this._renderer2.removeClass(
                document.body,
                'with-loyalty-messages');
        }
    }

    public isiPhone(): boolean {
        return navigator.appVersion.indexOf('iPhone') !== -1;
    }

    public trackBy(index: number, item: ILoyaltyAppMessageModel): number {
        return item?.Id || index;
    }
}
